import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { BasePage } from '../../base.page';
import {
    CancelContractUseCase,
    FinalizeContractUseCase,
    GetContractUseCase,
    GetContractsUseCase,
    GetFirstHolderUseCase,
    GetParticipantsUseCase,
    GetValidateClientNotificationsUseCase,
    IdInterface,
    UserInterface,
    ValidateContractUseCase,
    ValidationStatus,
} from '../../../../core';
import { ConfirmDialog } from '../../../ui/dialog/confirm/confirm.dialog';
import { Contract, ContractLite, FullClient } from '../../../domain/data';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { FullDataPage } from '../full-data.page';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ValidationNotificationsDialog } from '../../../ui/dialog/validation-notifications/validation-notifications.dialog';
import { Id } from '../../../domain/data';


import { environment } from '../../../../../environments/environment';
import { delay } from 'rxjs/operators';

@Component({
    templateUrl: './full-data-list.page.html',
    styleUrls: ['./full-data-list.page.scss'],
})
export class FullDataListPage extends BasePage implements AfterViewInit, OnInit {
    public contract: Contract;
    public participants: FullClient[] = [];
    public isLegalPerson = false;
    public isClientPortal = environment.portalClient;
    public clientId: string;
    public contracts: ContractLite[] = [];

    constructor(
        parentEvents: ParentEvents,
        private cancelContractUseCase: CancelContractUseCase,
        private dialog: MatDialog,
        private finalizeContractUseCase: FinalizeContractUseCase,
        private fullDataPage: FullDataPage,
        private getContractUseCase: GetContractUseCase,
        private getContractsUseCase: GetContractsUseCase,
        private getFirstHolderUseCase: GetFirstHolderUseCase,
        private getParticipantsUseCase: GetParticipantsUseCase,
        private getValidateClientNotificationsUseCase: GetValidateClientNotificationsUseCase,
        private localStorage: LocalStorage,
        private router: Router,
        private validateContractUseCase: ValidateContractUseCase
    ) {
        super(parentEvents);
        fullDataPage.hideBackButton();
    }

    get user(): UserInterface {
        return this.fullDataPage.user;
    }

    get canFinalizeContract(): boolean {
        if (this.contract.isAdvisoryModelGDC()){
            if (!!this.contract.authorized){
                return (
                    this.contract &&
                    this.participants &&
                    this.participants.length > 0 &&
                    !this.participants.some((participant) => !participant.isComplete(true))
                );
            }
            else{
            return (
                this.contract &&
                this.participants &&
                this.participants.length > 0 &&
                !this.participants.some((participant) => !participant.isComplete(this.contract.isAdvisoryModelGDC()))
            );
        }}
        else{
        return (
            this.contract &&
            this.participants &&
            this.participants.length > 0 &&
            this.contract.isComplete() &&
            !this.participants.some((participant) => !participant.isComplete(this.contract.isAdvisoryModelGDC()))
        );
        }
    }

    get canValidateContract(): boolean {
        return (
            this.contract &&
            this.participants &&
            !this.participants.some((participant) => !participant.isValidated() && !participant.validation.isValid())
        );
    }

    get canFinalizeContractAdmin(): boolean {
        return (
            this.contract &&
            this.participants &&
            this.participants.length ===
                this.participants.filter((participant) => participant.isValidated() || !!participant.validation.status).length &&
            (this.contract.isValidated() ||
                !!this.contract.validation.status ||
                this.participants.some((participant) => !participant.isValidated() && !participant.validation.isValid()))
        );
    }

    ngOnInit() {
        this.getContract();
        this.getContracts();
        this.getFirstHolder();
        this.getParticipants();

        if (this.isClientPortal) {
            this.getValidateClientNotifications();
        }
    }

    private getContract() {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.contract = transaction.data as Contract;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    getContracts() {
        this.getContractsUseCase
            .bind({ code: Id.fromString(localStorage.getItem('ClientID')) })
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.contracts = transaction.data as ContractLite[];
                    this.contracts.forEach((value) => {
                        if(value.contract_relation == 'T'){
                            localStorage.setItem('IsTitular', 'true');
                        }
                    });
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
}

    private getFirstHolder() {
        this.getFirstHolderUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.isLegalPerson = transaction.data.isLegalPerson;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    private getParticipants() {
        this.getParticipantsUseCase.bind({ isFull: true }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.participants = transaction.data as FullClient[];
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    private getValidateClientNotifications() {
        this.getValidateClientNotificationsUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess && transaction.data.length > 0) {
                this.dialog.open(ValidationNotificationsDialog, {
                    data: transaction.data,
                });
            }
        });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    onEditAccount() {
        this.router.navigateByUrl(MainRoutes.FULL_DATA_ACCOUNT);
    }

    onEdit(participant: FullClient) {
        this.router.navigateByUrl(MainRoutes.FULL_DATA_PROFILE.replace(':id', encodeURIComponent(String(participant.encryptedCode))));
    }

    onCancel() {
        const dialogRef = this.dialog.open(ConfirmDialog, {
            data: { text: 'dialog.confirm-cancel-onboarding' },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.cancelContractUseCase.bind().subscribe((transaction) => {
                    if (transaction.isSuccess) {
                        this.localStorage.clientId = undefined;
                        this.localStorage.clientCode = undefined;
                        this.parentEvents.cancel();
                    } else if (!transaction.isAuthError) {
                        this.dialog.open(ErrorDialog, {
                            data: { text: transaction.error },
                        });
                    }
                });
            }
        });
    }

    onFinalize() {
        const dialogRef: any = this.dialog.open(ConfirmDialog, {
            data: {text: (environment.portalClient ? 'dialog.wait-validation-client' : 'dialog.wait-validation')}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.finalizeContractUseCase.bind()
                    .subscribe(transaction => {
                        if (transaction.isSuccess) {
                            this.parentEvents.cancel();
                        } else if (!transaction.isAuthError) {
                            this.dialog.open(ErrorDialog, {data: {text: transaction.error}});
                        }
                    });
            }
        });
    }

    onValidateFinalize() {
        let dialogRef: any;

        if (this.participants.some(participant => participant.validation.status === ValidationStatus.REJECT)) {
            dialogRef = this.dialog.open(ConfirmDialog, {
                data: {text: (this.contract.agent && this.contract.agent.userCode === 'portalweb' ? 'dialog.message-reject-client' : 'dialog.message-reject')}
            });
        } else if (this.participants.some(participant => participant.validation.status === ValidationStatus.REVISE)
            || this.contract.validation.status === ValidationStatus.REVISE) {
            dialogRef = this.dialog.open(ConfirmDialog, {
                data: {text: (this.contract.agent && this.contract.agent.userCode === 'portalweb' ? 'dialog.message-revise-client' : 'dialog.message-revise')}
            });
        } else {
            dialogRef = this.dialog.open(ConfirmDialog, {
                data: {text: (this.contract.agent && this.contract.agent.userCode === 'portalweb' ? 'dialog.message-valid-client' : 'dialog.message-valid')}
            });
        }

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.user.isAdminPBC && !this.contract.validation.status) {
                    this.contract.validation.status = ValidationStatus.REJECT;
                }

                this.validateContractUseCase.bind()
                    .subscribe(transaction => {
                        if (transaction.isSuccess) {
                            this.parentEvents.cancel();
                        } else if (!transaction.isAuthError) {
                            this.dialog.open(ErrorDialog, {data: {text: transaction.error}});
                        }
                    });
            }
        });
    }
}
